/**
 * This list should be removed when not used anymore - will slowly migrate to themes.ts IAttenderTheme used by the ThemeProvider
 */

const colors = {
  mainTextColor: '#277982',
  pillColor: 'red',
  yellow: '#ffd31a',
  yellowDark: '#ffc745',
  orange: '#f0711f',
  white: '#ffffff',
  red: '#fb4856',
  redText: '#D01121',
  offWhite: '#f5f5f5',
  // blue: '#2a848e',
  white_rgb: '255,255,255',
  blue_rgb: '39, 121, 130',
  blue_50: 'rgba(39, 121, 130,.5) ',
  faded_blue: '#707070',
  light_blue: '#72ACB3',
  faded_white: '#F7F7F7',
  green: 'green',
  black: '#000',
  gray: '#707070',
  gray_50: 'rgba(112, 112, 112, .5)',
  gray_20: 'rgba(112, 112, 112, .2)',
  gray_10: 'rgba(186, 186, 186, .1)',
  darkenedRed: '#64020a',
  darkenedYellow: '#806600',
  darkenedBlue: '#42757b',
};

export { colors };
